"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cond = exports.fromPromise = exports.unwrap = exports.catchError = exports.flatMap = exports.combineLatest = exports.map = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const domain_1 = require("./domain");
const index_1 = require("./index");
function map(mapper) {
    return observable => index_1.markWrappedObservable(index_1.wrap(observable).pipe(operators_1.map(v => {
        switch (v.status) {
            case "fulfilled": {
                try {
                    return domain_1.createFulfilledWrapped(mapper(v.value));
                }
                catch (error) {
                    return domain_1.createRejectedWrapped(error);
                }
            }
            case "pending":
                return v;
            case "rejected":
                return v;
        }
    })));
}
exports.map = map;
function combineLatest(array) {
    return index_1.markWrappedObservable(rxjs_1.combineLatest(array.map(index_1.wrap)).pipe(operators_1.map(resultArray => {
        let pending = false;
        let rejected = [];
        const combined = new Array(resultArray.length);
        resultArray.forEach((w, idx) => {
            switch (w.status) {
                case "pending":
                    pending = true;
                    break;
                case "rejected":
                    rejected.push(w);
                    break;
                case "fulfilled":
                    combined[idx] = w.value;
            }
        });
        if (rejected.length > 0) {
            const error = rejected[0].error;
            const reload = () => {
                rejected.forEach(r => r.reload());
            };
            return domain_1.createRejectedWrapped(error, reload);
        }
        else if (pending) {
            return domain_1.pendingWrapped;
        }
        else {
            return domain_1.createFulfilledWrapped(combined);
        }
    }), operators_1.distinctUntilChanged()));
}
exports.combineLatest = combineLatest;
function flatMap(mapper) {
    return observable => index_1.markWrappedObservable(index_1.wrap(observable).pipe(operators_1.mergeMap(x => {
        switch (x.status) {
            case "pending":
                return rxjs_1.of(domain_1.pendingWrapped);
            case "rejected":
                return rxjs_1.of(x);
            case "fulfilled":
                return index_1.wrap(rxjs_1.from(mapper(x.value)));
        }
    }), operators_1.distinctUntilChanged()));
}
exports.flatMap = flatMap;
function catchError(mapper) {
    return observable => index_1.markWrappedObservable(index_1.wrap(observable).pipe(operators_1.mergeMap(v => {
        switch (v.status) {
            case "fulfilled":
                return rxjs_1.of(v);
            case "pending":
                return rxjs_1.of(domain_1.pendingWrapped);
            case "rejected":
                const result = mapper(v.error);
                if (result instanceof rxjs_1.Observable) {
                    return index_1.wrap(result);
                }
                else {
                    return index_1.wrap(rxjs_1.of(domain_1.createFulfilledWrapped(result)));
                }
        }
    })));
}
exports.catchError = catchError;
function unwrap() {
    return observable => index_1.wrap(observable).pipe(operators_1.mergeMap(v => {
        switch (v.status) {
            case "fulfilled":
                return rxjs_1.of(v.value);
            case "pending":
                return rxjs_1.NEVER;
            case "rejected": {
                return rxjs_1.throwError(v.error);
            }
        }
    }));
}
exports.unwrap = unwrap;
function fromPromise(promise) {
    return index_1.wrap(rxjs_1.from(promise));
}
exports.fromPromise = fromPromise;
function cond(ifTrue, ifFalse) {
    return wrapped => index_1.markWrappedObservable(index_1.wrap(wrapped).pipe(map(value => (value ? ifTrue : ifFalse))));
}
exports.cond = cond;
